export class QChartContent extends Array {
  constructor(...args) {
    super(...args);
  }

  Init() {}

  FindPairByID(objID) {
    var n = this.length;
    for (var i = 0; i < n; i++) {
      var pair = this[i];
      var serialObj = pair.fSerialDBObj;
      var sID = serialObj.GetObjectID();
      if (sID == objID) return pair;
    }

    return null;
  }

  GetRoots() {
    var rootList = new Array();
    var n = this.length;
    for (var i = 0; i < n; i++) {
      var pID = this[i].GetParentID();
      var pairObj = this.FindPairByID(pID);
      if (pairObj == null) rootList.push(this[i]);
    }

    return rootList;
  }

  GetChildren(aPair) {
    var children = new Array();
    var n = this.length;
    var serialObj = aPair.fSerialDBObj;
    var objID = serialObj.GetObjectID();

    var isDrillDown = aPair.IsDrillDown();
    if (isDrillDown) return null;

    for (var i = 0; i < n; i++) {
      var pID = this[i].GetParentID();
      if (pID == objID) children.push(this[i]);
    }

    return children;
  }
}
